import React from "react";
import "./Mask.css";

const mask = props => <div className="mask" onClick={props.click} />;

export default mask;
